module.exports = __webpack_public_path__ + "img/opet-infographic-10.8796cd0a.jpg";